/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 * Extracted ability-template data (was part of Abilities.ts). Pure data; consumed by Abilities.
*/

export const base_actions: Ability[] = [
		{
			label: "Melee Weapon Attack (STR)",
			name: "Melee Weapon Attack",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach ??? ft., one target. *Hit:* [STR ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Melee Weapon Attack (DEX)",
			name: "Melee Weapon Attack",
			attribute: 'Dexterity',
			desc: "*Melee Weapon Attack:* [DEX ATK] to hit, reach ??? ft., one target. *Hit:* [DEX ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Melee Spell Attack (INT)",
			name: "Melee Spell Attack",
			attribute: 'Intelligence',
			desc: "*Melee Spell Attack:* [INT ATK] to hit, reach ??? ft., one target. *Hit:* [INT ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Melee Spell Attack (WIS)",
			name: "Melee Spell Attack",
			attribute: 'Wisdom',
			desc: "*Melee Spell Attack:* [WIS ATK] to hit, reach ??? ft., one target. *Hit:* [WIS ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Melee Spell Attack (CHA)",
			name: "Melee Spell Attack",
			attribute: 'Charisma',
			desc: "*Melee Spell Attack:* [CHA ATK] to hit, reach ??? ft., one target. *Hit:* [CHA ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Ranged Weapon Attack (STR)",
			name: "Ranged Weapon Attack",
			attribute: 'Strength',
			desc: "*Ranged Weapon Attack:* [STR ATK] to hit, range ???/??? ft., one target. *Hit:* [STR ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Ranged Weapon Attack (DEX)",
			name: "Ranged Weapon Attack",
			desc: "*Ranged Weapon Attack:* [DEX ATK] to hit, range ???/??? ft., one target. *Hit:* [DEX ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Ranged Spell Attack (INT)",
			name: "Ranged Spell Attack",
			attribute: 'Intelligence',
			desc: "*Ranged Spell Attack:* [INT ATK] to hit, range ???/??? ft., one target. *Hit:* [INT ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Ranged Spell Attack (WIS)",
			name: "Ranged Spell Attack",
			attribute: 'Wisdom',
			desc: "*Ranged Spell Attack:* [WIS ATK] to hit, range ???/??? ft., one target. *Hit:* [WIS ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Ranged Spell Attack (CHA)",
			name: "Ranged Spell Attack",
			attribute: 'Charisma',
			desc: "*Ranged Spell Attack:* [CHA ATK] to hit, range ???/??? ft., one target. *Hit:* [CHA ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Melee or Ranged Weapon Attack (STR)",
			name: "Melee or Ranged Weapon Attack",
			attribute: 'Strength',
			desc: "*Melee or Ranged Weapon Attack:* [STR ATK] to hit, reach ??? ft. or range ???/??? ft., one target. *Hit:* [STR ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Melee or Ranged Weapon Attack (DEX)",
			name: "Melee or Ranged Weapon Attack",
			attribute: 'Dexterity',
			desc: "*Melee or Ranged Weapon Attack:* [DEX ATK] to hit, reach ??? ft. or range ???/??? ft., one target. *Hit:* [DEX ???d???] ??? damage.",
			group: "Generic Attacks"
		},
		{
			label: "Bite (STR)",
			name: "Bite",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR ???d???] piercing damage.",
			group: "Natural Attacks"
		},
		{
			label: "Bite (DEX)",
			name: "Bite",
			attribute: 'Dexterity',
			desc: "*Melee Weapon Attack:* [DEX ATK] to hit, reach 5 ft., one target. *Hit:* [DEX ???d???] piercing damage.",
			group: "Natural Attacks"
		},
		{
			label: "Claw (STR)",
			name: "Claw",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR ???d???] slashing damage.",
			group: "Natural Attacks"
		},
		{
			label: "Claw (DEX)",
			name: "Claw",
			attribute: 'Dexterity',
			desc: "*Melee Weapon Attack:* [DEX ATK] to hit, reach 5 ft., one target. *Hit:* [DEX ???d???] slashing damage.",
			group: "Natural Attacks"
		},
		{
			label: "Tail",
			name: "Tail",
			attribute: 'Strength',
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach ??? ft., one target. *Hit:* [STR ???d???] bludgeoning damage.",
			group: "Natural Attacks"
		},		
		{
			label: "Breath Weapon (Cone)",
			name: "Breath Weapon (Recharge ???)",
			desc: "The [MON] exhales ??? in a ???-foot cone. Each creature in that area must make a DC ??? Dexterity saving throw, taking [???d???] ??? damage on a failed save, or half as much damage on a successful one.",
			group: "Natural Attacks"
		},
		{
			label: "Breath Weapon (Line)",
			name: "Breath Weapon (Recharge ???)",
			desc: "The [MON] exhales ??? in a ???-foot line that is ??? feet wide. Each creature in that line must make a DC ??? Dexterity saving throw, taking [???d???] ??? damage on a failed save, or half as much damage on a successful one.",
			group: "Natural Attacks"
		},
		{
			name: "Constrict",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one creature. *Hit:* [STR ???d???] bludgeoning damage, and the target is grappled (escape DC ???). Until this grapple ends, the creature is restrained, and the [MON] can't constrict another target.",
			group: "Natural Attacks"
		},
		{
			name: "Life Drain",
			desc: "*Melee Spell Attack:*+??? to hit, reach ??? ft., one creature. *Hit:* [???d??? + ???] necrotic damage. The target must succeed on a DC ??? Constitution saving throw or its hit point maximum is reduced by an amount equal to the damage taken. This reduction lasts until the creature finishes a long rest. The target dies if this effect reduces its hit point maximum to 0.",
			group: "Natural Attacks"
		},
		{
			name: "Unarmed Strike",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one target. *Hit:* [STR 1] bludgeoning damage.",
			group: "Natural Attacks"
		},
		{
			name: "Multiattack",
			desc: "The [MON] makes two attacks.",
			group: "Natural Attacks"
		},
		{
			name: "Change Shape",
			desc: "The [MON] magically polymorphs into a humanoid or beast that has a challenge rating no higher than its own, or back into its true form. It reverts to its true form if it dies. Any equipment it is wearing or carrying is absorbed or borne by the new form (the [MON]'s choice).\nIn a new form, the [MON] retains its alignment, hit points, Hit Dice, ability to speak, proficiencies, Legendary Resistance, lair actions, and Intelligence, Wisdom, and Charisma scores, as well as this action. Its statistics and capabilities are otherwise replaced by those of the new form, except any class features or legendary actions of that form.",
			group: "Natural Abilities"
		},
		{
			label: "Change Shape (Humanoid)",
			name: "Change Shape",
			desc: "The [MON] magically polymorphs into a small or medium humanoid, or back into its true form. Its statistics are the same in each form. Any equipment the [MON] is wearing or carrying isn't transformed. If the [MON] dies, it reverts to its true form.",
			group: "Natural Abilities"
		},
		{
			name: "Etherealness",
			desc: "The [MON] magically enters the Ethereal Plane from the Material Plane, or vice versa.",
			group: "Natural Abilities"
		},
		{
			name: "Frightful Presence",
			desc: "Each creature of the [MON]'s choice that is within 120 feet of the [MON] and aware of it must succeed on a DC ??? Wisdom saving throw or become frightened for 1 minute. A creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success. If a creature's saving throw is successful or the effect ends for it, the creature is immune to the [MON]'s Frightful Presence for the next 24 hours.",
			group: "Natural Abilities"
		},
		{
			label: "Healing Touch",
			name: "Healing Touch (???/day)",
			desc: "The [MON] touches another creature. The target magically regains [???d??? + ???] hit points and is freed from any curse, disease, poison, blindness, or deafness.",
			group: "Natural Abilities"
		},
		{
			name: "Illusory Appearance",
			desc: "The [MON] covers itself and anything it is wearing or carrying with a magical illusion that makes it look like another creature of its general size and shape. The effect ends if the [MON] takes a bonus action to end it or if it dies.\nThe changes wrought by this effect fail to hold up to physical inspection. For example, the [MON] could appear to have no claws, but someone touching its hand might feel the claws. Otherwise, a creature must take an action to visually inspect the illusion and succeed on a DC ??? Intelligence (Investigation) check to discern that the [MON] is disguised.",
			group: "Natural Abilities"
		},
		{
			label: "Innate Spellcasting (Single Spell)",
			name: "Innate Spellcasting (???/day)",
			desc: "The [MON] can innately cast ??? (spell save DC ???), requiring no material components. Its innate spellcasting ability is ???.",
			group: "Natural Abilities"
		},
		{
			name: "Invisibility",
			desc: "The [MON] magically turns invisible until it attacks or casts a spell, or until its concentration ends (as if concentrating on a spell). Any equipment the [MON] wears or carries is invisible with it.",
			group: "Natural Abilities"
		},
		{
			label: "Leadership",
			name: "Leadership (Recharges after a Short or Long Rest)",
			desc: "For 1 minute, the [MON] can utter a special command or warning whenever a nonhostile creature that it can see within 30 ft. of it makes an attack roll or a saving throw. The creature can add a d4 to its roll provided it can hear and understand the [MON]. A creature can benefit from only one Leadership die at a time. This effect ends if the [MON] is incapacitated.",
			group: "Natural Abilities"
		},
		{
			name: "Read Thoughts",
			desc: "The [MON] magically reads the surface thoughts of one creature within ??? ft. of it. The effect can penetrate barriers, but 3 ft. of wood or dirt, 2 ft. of stone, 2 inches of metal, or a thin sheet of lead blocks it. While the target is in range, the [MON] can continue reading its thoughts, as long as the [MON]'s concentration isn't broken (as if concentrating on a spell). While reading the target's mind, the [MON] has advantage on Wisdom (Insight) and Charisma (Deception, Intimidation, and Persuasion) checks against the target.",
			group: "Natural Abilities"
		},
		{
			name: "Shapechanger",
			desc: "The [MON] can use its action to polymorph into a ???, or back into its true form. Its statistics, other than its size, are the same in each form. Any equipment it is wearing or carrying isn't transformed. It reverts to its true form if it dies.",
			group: "Natural Abilities"
		},
		{
			label: "Shapechanger (Lycanthrope)",
			name: "Shapechanger",
			desc: "The [MON] can use its action to polymorph into a ???-humanoid hybrid or into a ???, or back into its true form, which is humanoid. Its statistics, other than its AC, are the same in each form. Any equipment it is wearing or carrying isn't transformed. It reverts to its true form if it dies.",
			group: "Natural Abilities"
		},
		{
			name: "Teleport",
			desc: "The [MON] magically teleports, along with any equipment it is wearing or carrying, up to 120 feet to an unoccupied space it can see.",
			group: "Natural Abilities"
		}
	];
